import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "../data/content";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1400;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * value));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  );
};

const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="relative z-10 bg-royal"
    >
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-20 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="text-center lg:text-left lg:border-l border-beige/15 lg:pl-8 first:border-0"
            data-testid={`stat-${i}`}
          >
            <div className="font-display text-5xl md:text-6xl text-gold-gradient leading-none">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <div className="mt-3 font-accent uppercase tracking-[0.2em] text-sm text-beige/70">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
